<template>
  <div class="gerenzxtwo">
      <!-- 个人作品 -->
       <div v-if="bjzp == 0" class="gr-zuop">

       <div v-show="tw"  v-for="(item) in grzuopall" :key="item.id" class="gr-zuop-list">
         <!-- 作品封面 -->
         <div class="gr-zuop-list-img1">
  <img class="gr-zuop-list-img1"  :src="'http://ke.yunlearning.com:8081'+grzupimg" alt="###">
         </div>
         <!-- 作品描述 -->
         <div class="rztwo-msg">

      
           <p class="gr-zuop-list-title">{{title}}</p>
           <span class="gr-zuop-list-jieshao">{{message}}</span>
        
           <span class="gr-zuop-list-sp1">作品编号：A{{number}}</span>
           <span class="gr-zuop-list-sp2">{{praise}} 票</span>  
       
          
        
              </div>
           <!-- 分数  -->
           <div class="gr-zuop-list-bot">
                <p class="shenhepu" v-if="status == 0">[审核中]</p>
            <!-- <p class="shenhepu" v-if="status == 1">[审核通过]</p> -->
            <p @click="open()" class="shenhepu" v-if="status == -1">[审核未通过][详情]</p>
             <span v-if="status == 1" class="gr-zuop-list-bot-right-fentxt">专家打分:</span> 
             <span v-if="status == 1" class="gr-zuop-list-bot-right-fen">{{score}}分</span>
             <!-- 编辑删除 -->
             <div class="gr-zuop-list-bot-right">
               <span v-show="yeszp" @click="bianji()" class="gr-zuop-list-bot-right-updata">编辑</span>

               <span v-show="yeszp" @click="zpdel()" class="gr-zuop-list-bot-right-del">删除</span>

             </div>
           </div>
       </div>
    </div>
    <gerenzxthree v-if="bjzp == 1"></gerenzxthree>
  </div>
</template>

<script>
import GeRenzxtwo from '../css/GeRenzxtwo.css'
import axios from 'axios'
import gerenzxthree from './GeRenzxthree'
import { MessageBox } from 'element-ui'
export default {
   data(){
    return{
      grzuopall:[1],
   
      url:this.$apiUrl+'/index.php/teacher/Course',
      token:JSON.parse(localStorage.getItem("userinfo")).token,
      grzupimg:'',//封面
      title:'',//标题,
      message:'', //内容
      number:'', //作品编号
      praise:'',//投票
      status:'',//审核的状态
      score :'',//专家打分数
      score_status:'', //打分状态
      yeszp:true,
      zpid:'',
      tw:false,
      grzuop:'',
      bjzp:0,
      jury_id:'',
      nozpli:''
    }
},
mounted(){
  this.show();
  if (this.$store.state.userinfo.type==2) {
     this.zuoponce();
  }


},
methods:{
 show(){
   if (this.$store.state.userinfo.type==1) {
     this.typeshow=false;
   }else if (this.$store.state.status == 1 && this.$store.state.userinfo.type==2) {
      this.typeshow=true;
   }else if (this.$store.state.status == -1 && this.$store.state.userinfo.type==2) {
     this.typeshow=false;
   }else if (this.$store.state.status == 0 && this.$store.state.userinfo.type==2) {
     this.typeshow=false;
   }
 },
//  个人作品
 zuoponce(){
  
   let fa = new window.FormData;
   fa.append('token',this.token);
   axios({
  method: 'post',
  url: this.url,
  data:fa,
  // timeout: 1000,
}).then(res =>{
  if (res.data == null) {
this.tw = false;
    return false
  } else if(res.data.data){
    this.tw = true;
    this.grzuop = res.data.data;
  this.grzupimg = res.data.data.cover_img; //封面
  this.title = res.data.data.title;//标题
  this.message = res.data.data.message;//内容
  this.number = res.data.data.number;//编号
  this.praise = res.data.data.praise;//票数
  this.score = res.data.data.score;//打分
  this.status = res.data.data.status;//审核状态
  this.zpid = res.data.data.id; //作品ID
  this.jury_id = res.data.data.jury_id;//是否有评委
    this.nozpli = res.data.data.liyou; //作品被拒后的理由
 sessionStorage.setItem('grzuop',JSON.stringify(this.grzuop));
  sessionStorage.setItem('status',res.data.data.status);
  sessionStorage.setItem('grid',res.data.data.id);
   if ( res.data.data.jury_id == null) {
    this.yeszp = true;
  
  }else if (res.data.data.jury_id) {
     this.yeszp = false;
     
  }
  }
  
}).catch(error =>{

})
 },
//  删除作品
zpdel(){

    if (this.status == 1) {
  this.$message.error({
    message:'您的作品已审核通过，请勿删除！！！！',
    offset:200
  })
   return false
 }else if (this.status == 0) {
    this.$message.error({
      message:'请您耐心等待审核，勿删除！！！！',
      offset:200
    })
 }else if (this.status == -1) {
   let fas = new window.FormData;
   fas.append('id',this.zpid);
   fas.append('token',this.token);
   axios({
  method: 'post',
  url: this.$apiUrl+'/index.php/Teacher/courseDel',
  data:fas,
  // timeout: 1000,
}).then(res =>{
    if (res.data.code == 1) {
      this.$message({
        message:res.data.msg,
        offset:200
      });
      this.$router.go(0);
      sessionStorage.clear();
    }else if(res.data.code == 0){
      this.$message.error({
        message:'删除失败',
        offset:200
      })
    }
})
 }
},
// 编辑
bianji(){
  // 作品审核失败后进入可编辑状态
 if (this.status == -1) {

//这是点编辑后作品消失，上传显示
this.bjzp = 1;
this.$message.error({
  message:'请重新上传作品！！！',
  offset:200
})
 }else if (this.status == 0) {
   this.$message({
     message:'请耐心等待您的作品审核！！！',
     offset:200,
     type:'success'
   })
 }
 
 if (this.status==1&&this.jury_id==null) {
   this.bjzp = 1;
   this.$message({
     message:'您可以重新上传作品！！！',
     offset:200
   })
  
 }
},
// 作品审核失败的理由
   open() {
        this.$alert(this.nozpli, '作品审核未通过原因:', {
          confirmButtonText: '确定',
          callback: action => {
           
          }
        });
      }
},
components: {
  gerenzxthree
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/GeRenzxtwo.vue